<template>
  <div>
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        border-radius: 5px !important;
        border: solid 1px rgb(179 178 176 / 35%);
        padding: 2rem 1rem;
      "
    >
      <div style="width: 100%">
        <b-row class="itemsProductionOrder" style="align-items: normal">
          <div class="containerLineOne">
            <div class="containerInputItem" size="sm">
              <div
                style="
                  position: absolute;
                  top: -23px;
                  right: 0;
                  z-index: 0;
                  display: flex;
                  gap: 0.5rem;
                "
              >
                <div
                  v-if="lineSimpleItem.idProduto"
                  style="display: flex; align-items: center; gap: 0.5rem"
                >
                  <div
                    style="
                      position: relative;
                      position: relative;
                      width: 130px;
                      height: 100%;
                    "
                  >
                    <div class="radio-input">
                      <label>
                        <input
                          type="radio"
                          name="value-radio"
                          value="P1"
                          v-model="lineSimpleItem.tipoPreco"
                          @change="updateProductValue('P1')"
                        />
                        <span>VL . 1</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="value-radio"
                          value="P2"
                          v-model="lineSimpleItem.tipoPreco"
                          @change="updateProductValue('P2')"
                        />
                        <span>VL . 2</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="value-radio"
                          value="P3"
                          v-model="lineSimpleItem.tipoPreco"
                          @change="updateProductValue('P3')"
                        />
                        <span>VL . 3</span>
                      </label>
                      <span class="selection"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="inputItem" size="sm">
                <div class="infinite">
                  <InputInfinit
                    ref="idProduto"
                    label="Itens"
                    typeFilter="itens"
                    :isEdit="lineSimpleItem.id"
                    :dataInput.sync="lineSimpleItem.idProduto"
                    :onSearch="fillProductsComboBoxWithPaginate"
                    :openCreateModal="
                      () =>
                        handleModalCreateProduct(
                          'prodInSimpleItem',
                          lineSimpleItem.idProduto
                        )
                    "
                    :findAll="createdNewProducts"
                    :clearSelected="toggleClearSelect"
                    :searchFields="['nome', 'codRef']"
                    @selectItem="handleSetProductValues"
                  />

                  <span v-if="lineSimpleItem.estoque >= 0" class="alertStock"
                    >Estoque Atual : {{ lineSimpleItem.estoque }}</span
                  >
                  <span
                    v-if="lineSimpleItem.estoque < 0"
                    class="alertStockNegative"
                    >Estoque Atual : {{ lineSimpleItem.estoque }}</span
                  >
                </div>
              </div>
            </div>

            <div class="inputItemQnt">
              <InputQuant
                label="Qtd."
                :labelFixed="true"
                ref="refQtd"
                type="text"
                :dataInput.sync="lineSimpleItem.quantidade"
                @calculateTotal="handleCalculateTotal"
                isSelectAll
                :isDisabled="isActiveReplaceAll"
              />
            </div>

            <div class="inputItemVlUnit">
              <InputMoney
                label="Vl. Unit"
                labelFixed
                ref="refVlUnit"
                type="text"
                :dataInput.sync="lineSimpleItem.valorUnitario"
                @calculateTotal="handleCalculateTotal"
                isSelectAll
              />
            </div>

            <div class="inputItemVlTot">
              <InputMoney
                label="Vl. Total"
                labelFixed
                ref="valorTotal"
                type="text"
                isDisabled
                :dataInput.sync="lineSimpleItem.valorTotal"
                @calculateTotal="handleCalculateTotal"
              />
            </div>

            <div class="inputItemDesc">
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  position: relative;
                "
              >
                <InputMoney
                  v-if="!discountIsCheked"
                  label="Desc"
                  :labelFixed="true"
                  type="text"
                  :dataInput.sync="lineSimpleItem.desconto"
                  ref="discount"
                  @calculateTotal="handleCalculateTotal"
                  isSelectAll
                  :isDisabled="isActiveReplaceAll"
                />

                <InputPercentage
                  v-else
                  label="Desc"
                  :labelFixed="true"
                  type="text"
                  :dataInput.sync="lineSimpleItem.desconto"
                  ref="discount"
                  :isDisabled="discountToAllItems || isActiveReplaceAll"
                  @calculateTotal="handleCalculateTotal"
                  isSelectAll
                />
              </div>
            </div>

            <div class="itemToggleDesc" style="width: 52px; height: 30px">
              <label class="switch col-sm-2 col-md-2 col-lg-2 col-xl-2">
                <input
                  type="checkbox"
                  ref="typeDiscount"
                  @click="alterDiscountIsCheked"
                  v-model="discountIsCheked"
                  :disabled="validatorDesc || isActiveReplaceAll"
                />
                <div class="slider">
                  <span>R$</span>
                  <span>%</span>
                </div>
              </label>

              <div
                style="display: none"
                ref="enableLabelApplyAll"
                class="tooltipDiscount"
              >
                <div class="tooltipItems">
                  <div>
                    <label for="apllyAll">Aplicar em todos</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="apllyAll"
                      v-model="discountToAllItems"
                      @change="alterAllChecksDiscount"
                      :disabled="isActiveReplaceAll"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="containerInputObsAndBtn">
            <div class="inputItemObs">
              <Input
                label="Observação"
                :labelFixed="true"
                type="text"
                :dataInput.sync="lineSimpleItem.dadosAdicionais"
                ref="dadosAdicionais"
                :isDisabled="isActiveReplaceAll"
              />
            </div>

            <div
              v-if="!isActiveReplaceAll"
              class="btnAddMoreItems"
              :style="productLoading && 'align-items: flex-end'"
            >
              <button
                v-if="!productLoading"
                style="width: 100px; margin-top: 0.5rem"
                class="btnsProductionOrder btnAddMoreItems"
                @click="handleAddMoreItems"
              >
                {{ lineSimpleItem.id ? "Atualizar" : "Adicionar" }}
              </button>

              <div
                v-else
                style="
                  width: 30px;
                  height: 30px;
                  background-color: #00395d;
                  border-radius: 50%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 8px;
                "
              >
                <b-spinner class="spinProduct" />
              </div>
            </div>

            <!-- <div v-else style="display: flex; gap: 0.5rem">
              <button
                style="width: 70px; margin-top: 0.5rem"
                :class="`btnsProductionOrder applyReplaceAll ${
                  isLoadingToReplace && 'blockReplace'
                }`"
                @click="applyReplaceAll"
              >
                Substituir
              </button>

              <button
                style="width: 70px; margin-top: 0.5rem"
                class="btnsProductionOrder cancelReplaceAll"
                @click="cancelReplaceAll"
              >
                Cancelar
              </button>
            </div> -->
          </div>
        </b-row>
      </div>
    </div>

    <section class="containerTableItens">
      <div class="contentTableItens">
        <table
          class="tableProducts"
          style="width: 100%"
          v-if="tableProducts.length"
        >
          <thead>
            <tr>
              <th style="width: 200px">Nome</th>
              <th style="width: 60px">Qnt</th>
              <th style="width: 120px">Vl. Unit</th>
              <th style="width: 99px">Desc</th>
              <th style="width: 120px">Vl. Total</th>
              <th style="width: 40px"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="`tableItem ${isActiveReplaceAll && 'blockTable'}`"
              v-for="(productionOrderItem, idx) in tableProducts"
              :key="productionOrderItem.id"
              @click="
                !isLoadingToDelete &&
                  editProductsOfProductionOrder(productionOrderItem)
              "
            >
              <td style="width: 200px">
                <div style="display: flex; gap: 0.5rem; align-items: center">
                  <div
                    style="display: flex; flex-direction: column; gap: 0.3rem"
                  >
                    <span class="contentNumberItem"> {{ idx + 1 }}</span>
                  </div>

                  <div style="width: calc(100% - 20px)">
                    <p class="textEllipsis" style="margin: 0">
                      {{ productionOrderItem.nome }}
                    </p>

                    <p
                      class="textEllipsis"
                      style="margin: 0; font-size: 9px; color: gray"
                    >
                      <span
                        v-b-tooltip.hover.top="
                          productionOrderItem.dadosAdicionais
                        "
                      >
                        {{ productionOrderItem.dadosAdicionais }}
                      </span>
                    </p>
                  </div>
                </div>
              </td>
              <td style="width: 60px">{{ productionOrderItem.quantidade }}</td>
              <td style="width: 120px">
                {{ maskCurrency(productionOrderItem.valorUnitario) }}
              </td>
              <td style="width: 100px">
                {{
                  productionOrderItem.tipoDesconto === "porcentagem"
                    ? maskPercentage(productionOrderItem.desconto)
                    : maskCurrency(productionOrderItem.desconto)
                }}
              </td>
              <td style="width: 115px">
                <p class="textEllipsis" style="margin: 0">
                  {{ handleCalculateTotalInTable(productionOrderItem) }}
                </p>
              </td>
              <td style="width: 40px; position: relative; padding: 0">
                <span
                  :class="`contentRemoveItem ${
                    (isActiveReplaceAll ||
                      lineSimpleItem.id === productionOrderItem.id ||
                      isLoadingToDelete) &&
                    'blockRemove'
                  }`"
                  @click.stop="removeItens(productionOrderItem.id)"
                  v-b-tooltip.hover.top="'Excluir'"
                >
                  <b-icon-trash style="color: white" scale="1.5" />
                </span>

                <div class="contentCloneAndReplaceItem">
                  <!-- <span
                    ref="replaceAll"
                    v-b-tooltip.hover.top="'Substituir todos!'"
                    @click.stop="handleItemSelected(productionOrderItem)"
                    style="
                      width: 25px;
                      height: 25px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <b-icon-bookmarks-fill style="color: #a8a8a8" scale="1.5" />
                  </span> -->

                  <span
                    v-b-tooltip.hover.top="'Clonar'"
                    @click.stop="handleDuplicate(productionOrderItem)"
                    style="
                      width: 25px;
                      height: 25px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <b-icon-back style="color: #a8a8a8" scale="1.5" />
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="contentNotItems">
          <p>Nenhum produto adicionado...</p>
        </div>
      </div>
    </section>

    <ModalCreateProducts
      @getAllNewProduct="handleCreatedNewProduct"
      :idProductFromSearch="idProductFromSearch"
      modalName="prodInSimpleItem"
    />
  </div>
</template>

<script>
import { mixinSimpleItem } from "./mixins/SimpleItem";

export default {
  mixins: [mixinSimpleItem],
};
</script>

<style scoped>
#dadosVendaStyle {
  border: none !important;
}

.containerLineOne {
  width: 100%;
  display: flex;
  gap: 15px;
  position: relative;
}

.containerInputItem {
  width: 50%;
  position: relative;
  min-width: 320px;
}

.inputItem {
  width: 100%;
  min-width: 320px;
  position: relative;
}

.inputItemQnt {
  flex-shrink: 1;
  max-width: 8%;
}

.inputItemVlUnit,
.inputItemVlTot,
.inputItemDesc {
  width: 13.33%;
}

.inputItemObs {
  width: 50%;
  margin-top: 0.5rem;
}

.itemToggleDesc {
  position: relative;
}

.input:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}

.containerInputObsAndBtn {
  display: flex;
  gap: 15px;
  align-items: center;
}

.containerTableItens {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  flex-wrap: wrap-reverse;
}

.contentTableItens {
  width: 100%;
  height: 242px;
  border: dashed 1px #c1c1c1;
  border-radius: 5px;
  padding: 0.3rem 0.5rem;
}

.tableProducts {
  display: table;
  width: 100%;
  border-spacing: 0;
  margin-top: 0.5rem;
}

.tableProducts thead tr th {
  padding: 0 0.5rem;
  font-weight: normal;
}

.tableProducts thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.tableItem {
  height: 50px;
  background-color: whitesmoke;
  box-shadow: 0 1px 3px rgb(0 0 0 / 24%);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  position: relative;
  transition: ease 0.2s;
}

.tableItem:hover {
  background-color: rgb(218, 218, 218);
  transition: ease 0.2s;
}

.tableItem td {
  text-align: start !important;
  padding: 0 0.5rem;
}

.textEllipsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.spinProduct {
  color: white;
  width: 20px;
  height: 20px;
}

.contentNumberItem {
  height: 18px;
  width: 26px;
  padding: 0 0.3rem;
  min-width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: gray;
  color: white;
}

.contentRemoveItem {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 5px 5px 0;
  background-color: brown;
  box-shadow: -1px 0 2px rgb(0 0 0 / 24%);
}

.blockRemove {
  background-color: rgb(144, 85, 85);
  pointer-events: none !important;
  cursor: default !important;
}

.blockReplace {
  background-color: #0fbf4d84 !important;
  pointer-events: none !important;
  cursor: default !important;
}

.blockTable {
  background-color: rgb(218, 218, 218);
  pointer-events: none !important;
  cursor: default !important;
}

.contentCloneAndReplaceItem {
  position: absolute;
  right: 30px;
  top: 0;
  height: 100%;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
}

.contentNotItems {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentNotItems p {
  font-size: 16px;
  color: #c1c1c1;
}

.infinite {
  position: relative;
}

.radio-input input {
  display: none;
}

.radio-input {
  position: absolute;
  right: 0;
  top: -2px;
  display: flex;
  --container_width: 130px;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  color: #000000;
  width: var(--container_width);
  overflow: hidden;
  border: 1px solid rgba(53, 52, 52, 0.226);
}

.radio-input label {
  width: 100%;
  padding: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 11px;
  margin-bottom: 0px !important;
}

.selection {
  display: none;
  position: absolute;
  height: 100%;
  width: calc(var(--container_width) / 3);
  z-index: 0;
  left: 0;
  top: 0;
  transition: 0.15s ease;
}

.radio-input label:has(input:checked) {
  color: #fff;
}

.radio-input label:has(input:checked) ~ .selection {
  background-color: #3a4750;
  display: inline-block;
}

.radio-input label:nth-child(1):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 0 / 3));
}

.radio-input label:nth-child(2):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 1 / 3));
}

.radio-input label:nth-child(3):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 2 / 3));
}

p {
  margin: 0;
}

.btnsProductionOrder {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  height: 30px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.btnAddMoreItems {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancelReplaceAll {
  background-color: brown;
  border: solid 1px white;
  color: white;
  font-size: 10.5px !important;
  transition: ease-in all 0.1s;
}

.cancelReplaceAll:hover {
  background-color: rgb(134, 34, 34);
  transition: ease-in all 0.1s;
}

.applyReplaceAll {
  background-color: #0fbf4d;
  border: solid 1px white;
  color: white;
  font-size: 10.5px !important;
  transition: ease-in all 0.1s;
}

.applyReplaceAll:hover {
  background-color: #0ca241;
  transition: ease-in all 0.1s;
}

.isDisabled {
  background-color: #e1e1e1;
}

.alertStock {
  font-size: 10px;
  color: #3e66ae;
  padding-left: 10px;
}

.alertStockNegative {
  font-size: 10px;
  color: #ff1d08;
  padding-left: 10px;
}

.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.itemsProductionOrder {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-left: 0;
}

.tooltipDiscount {
  z-index: 3;
  width: 150px;
  padding: 5px;
  font-size: 12px;
  position: absolute;
  color: black;
  border-radius: 5px;
  top: -30px;
  right: -15px;
}

.tooltipItems {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 886px) {
  .contentTableItens {
    width: 100%;
  }
}

@media screen and (max-width: 1300px) {
  .inputItemObs {
    width: 270px;
  }

  .inputItemQnt {
    width: 80px;
  }

  .inputItemVlUnit {
    width: 100px;
  }

  .inputItemVlTot {
    width: 100px;
  }

  .inputItemDesc {
    width: 105px;
  }
}

@media screen and (min-width: 769px) {
  .tableProducts tbody {
    display: block;
    height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 0.5rem;
    padding: 5px !important;
  }
}

@media screen and (max-width: 800px) {
  .containerLineOne {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .containerInputItem {
    width: 80%;
  }

  .inputItem {
    width: 100%;
  }

  .inputItemQnt {
    width: 15% !important;
    max-width: 100px;
  }

  .inputItemVlUnit,
  .inputItemVlTot,
  .inputItemDesc {
    width: 26.5%;
  }

  .inputItemObs {
    width: 100%;
  }

  .itemToggleDesc {
    width: 12% !important;
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .tooltipDiscount {
    right: -85px;
    top: -28px;
  }

  .tableProducts tbody {
    display: block;
    height: 200px;
    margin-top: 0.5rem;
    padding: 5px !important;
  }

  .contentTableItens {
    overflow-x: auto;
  }
}

@media screen and (max-width: 575px) {
  .inputItemVlUnit {
    flex: 1 0 100px;
  }

  .inputItemVlTot,
  .inputItemDesc {
    flex: 1 0 100px;
  }

  .itemToggleDesc {
    width: 12% !important;
    position: relative;
  }
}

@media screen and (max-width: 475px) {
  .containerInputItem,
  .inputItem {
    width: 100%;
    min-width: 100% !important;
  }
}

@media screen and (max-width: 400px) {
  .itemsProductionOrder {
    margin: 0 !important;
  }

  .inputItemQnt {
    width: 60px;
    max-width: 60px;
  }

  .inputItemVlUnit {
    margin-top: 0;
    flex: 1 0 auto;
  }

  .inputItemVlTot {
    flex: 1 0 auto;
  }

  .inputItemDesc {
    flex: 1 0 auto;
    max-width: 70% !important;
    margin-top: 0;
  }

  .itemToggleDesc {
    margin-top: 0.5rem;
  }

  .inputItem {
    width: 100%;
    min-width: 100% !important;
  }

  .containerInputObsAndBtn {
    flex-wrap: wrap;
  }

  .inputItemObs {
    width: 100%;
  }

  .btnAddMoreItems {
    width: 100% !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .itemsProductionOrder {
    margin-left: 0px;
    margin-right: 0px;
  }

  .btnsProductionOrder {
    width: 140px;
    margin-top: 15px;
    font-size: 10px;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
  }
}

@media (min-width: 576px) and (max-width: 1200px) {
}

@media screen and (max-width: 700px) {
  .containerTableItens {
    padding-left: 15px;
  }

  .tooltipDiscount {
    right: -15px;
    top: -23px;
  }

  .row {
    gap: 10px;
  }

  .itemsProductionOrder {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px !important;
    padding-left: 16px;
    margin-right: 16px;
    width: 100%;
  }

  .inputItemVlUnit,
  .inputItemVlTot,
  .inputItemDesc {
    width: 25%;
  }
}

@media screen and (max-width: 547px) {
  .tooltipDiscount {
    right: -15px;
    top: -25px;
  }

  .containerInputItem {
    width: 100%;
  }

  .inputItemDesc,
  .itemToggleDesc {
    margin-top: 0.5rem;
  }
}
</style>